import { resolveSalesStatusCategory } from '@/composables/shared/useSalesStatus';

export const resolveSalesMultiCustomerStatusCategory = (row) => resolveSalesStatusCategory(row);

export const countSalesMultiCustomerRowsByStatus = (rows, statusKey) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows.filter((row) => resolveSalesMultiCustomerStatusCategory(row) === statusKey).length;
};

export const buildSalesMultiCustomerStatusTabs = (rows) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  return [
    { key: 'all', label: 'Todos', count: safeRows.length, showCount: true },
    { key: 'open', label: 'Abiertos', count: countSalesMultiCustomerRowsByStatus(safeRows, 'open'), showCount: true },
    { key: 'closed', label: 'Cerrados', count: countSalesMultiCustomerRowsByStatus(safeRows, 'closed'), showCount: true },
    { key: 'canceled', label: 'Cancelados', count: countSalesMultiCustomerRowsByStatus(safeRows, 'canceled'), showCount: true },
  ];
};

export const filterSalesMultiCustomerRowsByStatus = (rows, activeStatusTab) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (activeStatusTab === 'all') {
    return safeRows;
  }

  return safeRows.filter((row) => resolveSalesMultiCustomerStatusCategory(row) === activeStatusTab);
};

export const resolveSalesMultiCustomerName = (row) => {
  return String(row?.sale_name || row?.project || row?.name || row?.code || '').trim() || '-';
};
